import React from 'react';
import classNames from 'classnames';
import {
  Root, Content, Portal, Overlay,
} from '@radix-ui/react-dialog';
import styles from './Popup.module.css';
import { PopupProps } from './Popup.type';

export function Popup({
  className,
  open,
  setopen,
  width,
  height,
  children,
}: PopupProps) {
  if (typeof document === 'undefined') return null;

  return (
    <Root open={!!open} onOpenChange={(_open: boolean) => setopen(_open)}>
      <Portal>
        <Overlay className={styles.defaultOverlay} />
        <Content
          className={classNames(styles.defaultContent, className)}
          style={{
            height: Number.isFinite(height) ? `min(${height}px, 95vh)` : height,
            width: Number.isFinite(width) ? `min(${width}px, 100vw` : width,

          }}
          onOpenAutoFocus={(e) => e.preventDefault()}
        >
          {children}
        </Content>
      </Portal>
    </Root>
  );
}

Popup.defaultProps = {
  className: undefined,
};
